import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';
import { IMapMatrixResponse } from 'src/app/api/interfaces/global-map.interface';
import {
  setInitialMapData,
  updateLandData,
  updateMapData,
} from './globalMapState.actions';

export interface IGlobalMapState {
  mapMatrix: IMapMatrixResponse[];
}

export interface IMapActions {
  type:
    | '[Auth API] set initial matrix Success'
    | '[Auth API] update land Success'
    | '[Auth API] update matrix Success'
    | string;
}

export const initialState: IGlobalMapState = {
  mapMatrix: [],
};

const _globalMapReducer = createReducer(
  initialState,
  on(setInitialMapData, (state, { responseData }) => {
    return { ...state, mapMatrix: responseData };
  }),
  on(updateLandData, (state, { responseData }) => {
    return {
      ...state,
      mapMatrix: state.mapMatrix.map((el) =>
        el.coordinateX === responseData.coordinateX &&
        el.coordinateY === responseData.coordinateY
          ? responseData
          : el
      ),
    };
  }),
  on(updateMapData, (state, { responseData }) => {
    return { ...state, mapMatrix: state.mapMatrix.concat(responseData) };
  })
);

export function globalMapReducer(
  state: IGlobalMapState | undefined,
  action: IMapActions
) {
  return _globalMapReducer(state, action);
}

export const selectGlobalMapState = createSelector(
  createFeatureSelector<IGlobalMapState>('globalMap'),
  (state) => state
);
